module.exports = __webpack_public_path__ + "img/img4.249f49b4.jpg";